<template>
  <div id="zhibosuju" :style="{paddingTop:page_padding}" class="relativeItem">
    <!--导航-->
    <nav class="flex-box whiteB zhibonav">
      <div :class="{ac:see === 0}" @click="see = 0">
        今日直播数据
        <span></span>
      </div>
      <div :class="{ac:see === 1}" @click="see = 1">
        直播周报
        <span></span>
      </div>
    </nav>

    <!--今日直播数据-->
    <jinrishuju v-if="see == 0"></jinrishuju>

    <!--直播周数据-->
    <zhoushuju v-if="see === 1"></zhoushuju>

  </div>
</template>














<script>
import jinrishuju from "./jinrishuju";
import zhoushuju from "./zhoushuju";

export default {
  name: "zhibosuju",
  components: { jinrishuju, zhoushuju },
  data() {
    return {
      see: 0, //导航定位
      page_padding: "0px" //页面顶部padding
    };
  },
  methods: {
    /**这是页面顶部padding */
    set_page_padding() {
      let nav = document.querySelector(".zhibonav");
      this.page_padding = nav.clientHeight + 2 + "px";
    }
  },
  mounted() {
    this.$tool.setTitle("直播数据");
    this.set_page_padding();
  }
};
</script>















<style scoped>
#zhibosuju {
  background: white;
  height: 100vh;
  overflow-y: scroll;
}
/**顶部导航 */
nav {
  width: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 3;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
}
nav::after {
  position: absolute;
  content: "";
  height: 80%;
  width: 1px;
  background: #f0f0f0;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
nav div {
  position: relative;
  width: 50%;
  text-align: center;
  padding: 5% 0;
  font-size: 13px;
  transition: color 0.2s;
}
nav span {
  position: absolute;
  display: block;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background: #ff4da4;
  transition: width 0.2s;
}
nav .ac {
  color: #ff4da4;
}
nav .ac span {
  width: 83%;
}
</style>

